import { objectHasKeys } from '@/utils/comparators'

/**
* Array with top destination country codes based on total phone calls made from a specific country.
*/
const topDestinations = (state) => () => {
  let countries = objectHasKeys(state.topDestinations)
    ? Object.keys(state.topDestinations)
    : []
  return countries
}

export default {
  topDestinations
}



// WEBPACK FOOTER //
// ./src/store/modules/communication/countries/getters.js